<template>
  <div class="d-flex" style="min-height: 45vw">
    <div class="content p-4 w-100">
      <VehicleTabs v-if="isManagementOffice || isSubManagementOffice || isInstallationOffice" class="mb-4"/>
      <h4 class="card-title mt-0">{{ title }}</h4>
      <div class="row mr-3 ml-3 v-theme--light">
        <div
          class="col-5"
          :class="
            !errors.managementOffice || errors.managementOffice?.length == 0
              ? ''
              : 'error'
          "
        >
          <ManagementOfficeAutoComplete
            v-model="form.managementOffice"
            :error-messages="errors.management_officeable_id"
            selectFirstIfOnlyOne
            :initialManagementId="initialManagementId"
            :initialManagementType="initialManagementType"
            :clearable="managementOfficeClearable"
            :disabled="isInstallationOffice"
          />
        </div>
        <div
          class="col-5"
          :class="
            !errors.operationOffice || errors.operationOffice?.length == 0
              ? ''
              : 'error'
          "
        >
          <SingleOperationOfficeAutoComplete
            :label="i18n.global.t('pages.vehicles.operationOffice')"
            v-model="form.operationOffice"
            :managementOffice="form.managementOffice"
            :error-messages="errors.operation_office_id"
            selectFirstIfOnlyOne
            :initialOperationId="initialOperationId"
            :clearable="operationOfficeClearable"
            :disabled="isInstallationOffice"
          />
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <VehicleVerifyImage
            v-model="vehicle_verify_image"
            :form="form"
            :modelId="form.id"
            :errors="errors"
            :isInstallationOffice="isInstallationOffice"
            @removeImage="removeImage"
          />
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <v-text-field
            class="pt-2"
            v-model="form.frames_number"
            :error-messages="errors.frames_number"
            :disabled="isInstallationOffice"
            clearable
            @click:clear="clearFormField('frames_number')"
          >
            <template v-slot:label>
              {{ i18n.global.t('pages.vehicles.framesNumber') }}
              <span style="color: red">
                <strong>*</strong>
              </span>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <v-text-field
            class="pt-2"
            v-model="form.vehicle_inspection_information"
            :error-messages="errors.vehicle_inspection_information"
            :disabled="isInstallationOffice"
            clearable
            @click:clear="clearFormField('vehicle_inspection_information')"
          >
            <template v-slot:label>
              {{ i18n.global.t('pages.vehicles.form.vehicleInspectionInformation') }}
              <span style="color: red">
                <strong>*</strong>
              </span>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <v-text-field
            class="pt-2"
            v-model="form.number_plate"
            :error-messages="errors.number_plate"
            :disabled="isInstallationOffice"
            clearable
            @click:clear="clearFormField('number_plate')"
          >
            <template v-slot:label>
              {{ i18n.global.t('pages.vehicles.numberPlate') }}
              <span style="color: red">
                <strong>*</strong>
              </span>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <v-text-field
            class="pt-2"
            :label="i18n.global.t('pages.vehicles.registrationNumber')"
            v-model="form.registration_number"
            :disabled="isInstallationOffice"
            clearable
            @click:clear="clearFormField('registration_number')"
          />
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-9">
          <v-text-field
            class="pt-2"
            :label="i18n.global.t('pages.vehicles.form.mileageMeter')"
            v-model="form.mileage_meter"
            :error-messages="errors.mileage_meter"
            clearable
            @click:clear="clearFormField('mileage_meter')"
          />
        </div>
        <div class="col-1" style="position: relative">
          <p style="position: absolute; bottom: 0px; margin: 0px">km</p>
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <DigitacoMappingAutoComplete
            v-if="loaded"
            v-model="form.digital_tacograph"
            :initialItemId="initialDigitacoMappingId"
            :operationOffice="form.operationOffice"
            :errorMessages="errors.digital_tacograph"
            :readonly="isOperationOffice"
            :disabled="isInstallationOffice"
            @click="isDigitacoMappingClicked = true"
          />
        </div>
      </div>
      <div
        v-if="!isSelectedTeltonikaDevice"
        class="row mr-3 ml-3 v-theme--light"
      >
        <div class="col-10">
          <DigitalTacographFWCopyAutoComplete
            v-if="loaded"
            v-model="form.digital_tacograph_FW_copy"
            :initialItemId="initialDigitalTacographFWCopyId"
            :operationOffice="form.operationOffice"
            :error="errors.digital_tacograph_FW_copy"
            :readonly="isOperationOffice"
            :disabled="isInstallationOffice"
          />
        </div>
      </div>
      <div class="row mr-3 ml-3 v-theme--light">
        <div class="col-10">
          <DepartmentAutoComplete
            v-model="form.department"
            :operationOffices="operationOffices"
            :initialItemId="form.department_id"
            :selectFirstIfOnlyOne="false"
            :disabled="isInstallationOffice"
          />
        </div>
      </div>
      <div
        v-if="isManagementOffice"
        class="mr-3 ml-3 v-theme--light"
      >
        <div class="row pl-4 d-flex align-items-center">
          <div class="col-7 col-md-2">
            <h6 class="pt-2">{{ i18n.global.t('pages.vehicles.form.isDailyReportJobDisabled') }}</h6>
          </div>
          <div class="col-5 col-md-10 pt-0 pb-0">
            <v-switch
              v-model="form.is_daily_report_job_disabled"
              color="warning"
            ></v-switch>
          </div>
        </div>
        <v-alert
          v-if="form.is_daily_report_job_disabled"
          type="warning"
          class="mt-2"
        >
          {{ i18n.global.t('pages.vehicles.form.dailyReportJobDisabledAlert') }}
        </v-alert>
      </div>
      <IniFileSetting
        v-if="isDisplayIniFileSetting"
        :item="form"
        :initialModel="initialModel"
        :selectedDevice="form.digital_tacograph"
        :selectedOperationOffice="form?.operationOffice"
        :selectedSimType="simType ?? undefined"
        :selectedAccesspoint="accessPoint ?? undefined"
        v-model="form.parameters"
        :errors="errors"
        :selfOfficeType="selfOfficeType"
        :vehicleForm="vehicleForm"
        :isOperationOffice="isOperationOffice"
        :isLatestStatus="isLatestStatus"
        :sensorSetting="form.sensor_setting"
        :isDigitacoMappingClicked="isDigitacoMappingClicked"
        :parentLoaded="loaded"
        :isInstallationOffice="isInstallationOffice"
        @changeAccessPoint="changeAccessPoint"
        @changeSimType="changeSimType"
        @changeIsLatestStatus="changeIsLatestStatus"
        @updateConfigHash="updateConfigHash"
      ></IniFileSetting>
    </div>
    <div class="form-footer p-2">
      <router-link :to="{ name: 'Vehicle' }">
        <v-btn class="ma-2 reset-btn">
          {{ i18n.global.t('common.cancelBtn') }}
        </v-btn>
      </router-link>
      <v-btn
        v-if="showableUpdateButton && isAuthority"
        class="ma-2 exec-btn"
        @click="submit"
        :loading="running"
        :disabled="hasItemError || hasError"
      >
        {{ i18n.global.t('pages.common.button.conservation') }}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import DigitacoMappingAutoComplete from '@/components/VehicleFormParts/DigitacoMappingAutoComplete.vue';
import DigitalTacographFWCopyAutoComplete from '@/components/VehicleFormParts/DigitalTacographFWCopyAutoComplete.vue';
import IniFileSetting from '@/components/VehicleFormParts/IniFileSetting.vue';
import Api from '@/services/api/ApiServiceFabrick';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { ObjectToFormData, deleteParams, firstFile } from '@/services/functions';
import { scrollToErrorComponent } from '@/services/validators';
import i18n from '@/lang/i18n';
import VehicleTabs from '@/components/VehicleTabs.vue';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
  OPERATION_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE,
  INSTALLATION_OFFICE_TYPE,
  TELTONIKA_DEVICE_TYPE_IDS,
} from '@/services/consts';
import VehicleVerifyImage from '@/components/VehicleFormParts/VehicleVerifyImage.vue';

const props = defineProps<{
  showFlash?: (message: string, type: string, fadeout: boolean) => void
  switchContentLoading?: (isLoading: boolean) => void
}>();

const route = useRoute();
const router = useRouter();
const { loginWithRedirect } = useAuth();

const form = ref<any>({
  parameters: {},
  is_daily_report_job_disabled: false,
});
const initialModel = ref<any>(null);
const isCreating = ref(false);
const title = ref('');
const errors = ref<any>({});
const vehicle_verify_image = ref<File | File[] | null>([]);
const selfOfficeType = ref<string | null>(null);
const digitalTacographFWCopyId = ref<any>(null);
const vehicleForm = ref<any>(null);
const showableUpdateButton = ref(false);
const isAuthority = ref(false);
const loaded = ref(false);
const running = ref(false);
const simType = ref<string | null>(null);
const accessPoint = ref<string | null>(null);
const isOperationOffice = ref(false);
const isManagementOffice = ref(false);
const isSubManagementOffice = ref(false);
const isInstallationOffice = ref(false);
const isLatestStatus = ref(true);
const configHash = ref<string | null>(null);
const initialOperationId = ref<number | undefined>(undefined);
const initialManagementId = ref<number | undefined>(undefined);
const initialManagementType = ref<string | undefined>(undefined);
const initialDepartmentId = ref<number | null | undefined>(undefined);
const initialDigitacoMappingId = ref<number | undefined>(undefined);
const initialDigitalTacographFWCopyId = ref<any>(undefined);
const deletekeys = ['operationOffice', 'managementOffice', 'sim', 'ini_file'];
const hasError = ref(false);
const hasItemError = ref(false);
const isDigitacoMappingClicked = ref(false);
const isRemoveVerifyImg = ref(false);

const operationOffices = computed(() => {
  if (form.value.operationOffice) return [form.value.operationOffice];
  return [];
});

const managementOfficeClearable = computed(() => {
  return !isSubManagementOffice.value && !isOperationOffice.value;
});

const operationOfficeClearable = computed(() => {
  return !isOperationOffice.value;
});

const routeVehicleId = computed<number | null>(() => {
  const idParam = route.params.id;
  if (!idParam) return null;
  const normalized = Array.isArray(idParam) ? idParam[0] : idParam;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? null : parsed;
});

const isSelectedTeltonikaDevice = computed(() => {
  if (form.value.digital_tacograph === null || form.value.digital_tacograph === undefined) {
    return false;
  } else if (typeof form.value.digital_tacograph === 'number' && form.value.device?.id) {
    return TELTONIKA_DEVICE_TYPE_IDS.includes(form.value.device?.model_type);
  }

  return TELTONIKA_DEVICE_TYPE_IDS.includes(form.value.digital_tacograph?.model_type);
});

const isDisplayIniFileSetting = computed(() => {
  return vehicleForm.value && !isSelectedTeltonikaDevice.value;
});

function changeAccessPointToSpace(targetAccessPoint: string | null) {
  switch (targetAccessPoint) {
    case 'BridgeDocomap':
      return 'Bridge docomap';
    case 'IoTCore':
      return 'IoT Core';
    case 'IoTGW':
      return 'IoT GW';
    default:
      return targetAccessPoint;
  }
}

function changeAccessPointToUpperCamelCase(targetAccessPoint: string | null) {
  switch (targetAccessPoint) {
    case 'Bridge docomap':
      return 'BridgeDocomap';
    case 'IoT Core':
      return 'IoTCore';
    case 'IoT GW':
      return 'IoTGW';
    default:
      return targetAccessPoint;
  }
}
function removeImage() {
  form.value.vehicle_verify_image = [];
  vehicle_verify_image.value = [];
  isRemoveVerifyImg.value = true;
}

function setSimAndAccessPoint(data: any) {
  simType.value = data?.sim ?? null;
  accessPoint.value = changeAccessPointToSpace(data?.access_point) ?? null;
}

function compareHash(compareParams: any) {
  if (!simType.value || !accessPoint.value) {
    return true;
  }
  const simAndAccessPoint = `${simType.value}.${changeAccessPointToUpperCamelCase(accessPoint.value)}`;
  const latestConfigHash = vehicleForm.value?.default_params?.[simAndAccessPoint]?.['config_hash'];
  return latestConfigHash == compareParams;
}

function changeSimType(val: string) {
  if (simType.value != val) isLatestStatus.value = true;
  simType.value = val;
}

function changeAccessPoint(val: string) {
  if (accessPoint.value != val) isLatestStatus.value = true;
  accessPoint.value = val;
}

function changeIsLatestStatus(bool: boolean) {
  isLatestStatus.value = bool;
}

function updateConfigHash(val: string) {
  if (isLatestStatus.value) configHash.value = val;
}

function makeParams() {
  const {
    operationOffice,
    managementOffice,
    digital_tacograph,
    digital_tacograph_FW_copy,
    department,
  } = form.value;

  let preparedFormData = {
    ...JSON.parse(JSON.stringify(form.value)),
    operation_office_id: operationOffice?.id,
    management_officeable_id: managementOffice?.id,
    management_officeable_type: managementOffice?.type,
    sim_type: simType.value,
    access_point: changeAccessPointToUpperCamelCase(accessPoint.value),
    config_hash: configHash.value,
    digital_tacograph: digital_tacograph?.id ?? digital_tacograph ?? '',
    department_id: department?.id ?? '',
    is_remove_verify_img: isRemoveVerifyImg.value,
  } as any;

  if (operationOffice?.tdsensor === false) {
    preparedFormData.parameters.tdsensor.tdrfsensor = 'OFF';
  }

  if (digital_tacograph_FW_copy) {
    preparedFormData.digital_tacograph_FW_copy = digital_tacograph_FW_copy.id;
  }
  if (preparedFormData.parameters?.tdsensor?.sensor_setting) {
    preparedFormData.sensor_setting = preparedFormData.parameters.tdsensor.sensor_setting;
    delete preparedFormData.parameters.tdsensor.sensor_setting;
  }

  preparedFormData = deleteParams(preparedFormData, deletekeys);
  Object.keys(preparedFormData?.parameters?.speed_alert ?? {}).forEach((key) => {
    if (typeof preparedFormData.parameters.speed_alert[key] === 'number') {
      preparedFormData.parameters.speed_alert[key] = preparedFormData.parameters.speed_alert[key].toString();
    }
  });

  const formData = new FormData();
  const verifyImage = firstFile(vehicle_verify_image.value);
  if (verifyImage) {
    formData.append('img', verifyImage);
  }

  ObjectToFormData(preparedFormData, formData, '');

  const machineId = digital_tacograph?.name ?? '';
  formData.set('parameters[common][machine_id]', machineId);

  return formData;
}

function submit() {
  running.value = true;
  const params = makeParams();

  Api()
    .createOrUpdateVehicle(routeVehicleId.value, params as any)
    .then(() => {
      props.showFlash?.(i18n.global.t('pages.common.messages.success'), 'success', true);
      running.value = false;
      router.push('/vehicles');
    })
    .catch((error) => {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({
            appState: { targetUrl: location.pathname },
          });
          break;
        case 403:
          location.reload();
          break;
        case 422:
          errors.value = res.data.errors;
          scrollToErrorComponent();
      }
      running.value = false;
    });
}

async function getItem() {
  if (!routeVehicleId.value) {
    loaded.value = true;
    showableUpdateButton.value = true;
    props.switchContentLoading?.(false);
    return;
  }
  await Api()
    .getVehicle(routeVehicleId.value)
    .then((data) => {
      if (!data.id) {
        loaded.value = true;
        return router.push('/vehicles/form');
      }
      form.value = data;
      if (form.value?.parameters?.device) {
        form.value.parameters.device.mqtt_cid = '';
      }

      form.value.operationOffice = {
        id: data.operation_office_id,
      };
      form.value.managementOffice = {
        id: data.management_officeable_id,
        type: data.management_officeable_type,
      };
      initialDepartmentId.value = data.department_id;
      initialModel.value = JSON.parse(JSON.stringify(form.value));
      initialManagementId.value = data.management_officeable_id;
      initialManagementType.value = data.management_officeable_type;
      initialOperationId.value = form.value.operationOffice.id;
      initialDigitacoMappingId.value = form.value.digital_tacograph;
      initialDigitalTacographFWCopyId.value = (data as any).digital_tacograph_FW_copy;
      digitalTacographFWCopyId.value = form.value.digital_tacograph_FW_copy;
      setSimAndAccessPoint(form.value);
      configHash.value = form.value.config_hash;
      isLatestStatus.value = compareHash(configHash.value);
    });
  loaded.value = true;
  showableUpdateButton.value = true;
  props.switchContentLoading?.(false);
}

function getVehicleForm() {
  Api()
    .getVehicleForm()
    .then((data) => {
      vehicleForm.value = data;
      getItem();
    });
}

function clearFormField(field: string) {
  form.value[field] = '';
}

watch(() => form.value.digital_tacograph_FW_copy, () => {
  const id = form.value?.digital_tacograph_FW_copy?.id ?? form.value?.digital_tacograph_FW_copy;
  if (id == digitalTacographFWCopyId.value) {
    return;
  }
  digitalTacographFWCopyId.value = id;
  if (!form.value.digital_tacograph_FW_copy?.vehicle) {
    return;
  }

  const beforeMqttCid = form.value?.parameters?.device?.mqtt_cid;
  form.value.parameters = form.value.digital_tacograph_FW_copy.vehicle.parameters;
  if (form.value?.parameters?.device) {
    form.value.parameters.device.mqtt_cid = beforeMqttCid;
  }
  setSimAndAccessPoint(form.value.digital_tacograph_FW_copy.vehicle);
  configHash.value = form.value.digital_tacograph_FW_copy.vehicle.config_hash;
  isLatestStatus.value = compareHash(configHash.value);
}, { deep: true });

watch(() => form.value.digital_tacograph, () => {
  if (!form.value?.parameters?.common) {
    return;
  }
  form.value.parameters.common.machine_id = form.value.digital_tacograph?.name;
}, { deep: true });

onMounted(() => {
  props.switchContentLoading?.(true);
  isCreating.value = !routeVehicleId.value;
  title.value = isCreating.value
    ? i18n.global.t('pages.vehicles.title.create')
    : i18n.global.t('pages.vehicles.title.edit');
  document.title = title.value;

  Api().getSelfAccount().then((data) => {
    selfOfficeType.value = data?.login_organization_type ?? null;
    isOperationOffice.value =
      selfOfficeType.value == OPERATION_OFFICE_TYPE ||
      selfOfficeType.value == DEPARTMENT_OFFICE_TYPE;
    isManagementOffice.value = selfOfficeType.value == MANAGEMENT_OFFICE_TYPE;
    isSubManagementOffice.value = selfOfficeType.value == SUB_MANAGEMENT_OFFICE_TYPE;
    isInstallationOffice.value = selfOfficeType.value == INSTALLATION_OFFICE_TYPE;
  });

  AuthorityCacheApi.getWithParse().then((authorityList) => {
    if (isCreating.value) {
      isAuthority.value = !!authorityList['octlink.vehicle.create'];
    } else {
      isAuthority.value = !!authorityList['octlink.vehicle.update'];
    }
    if (!authorityList['octlink.vehicle.read']) {
      router.push('/');
    }
  });

  getVehicleForm();
});

onBeforeUnmount(() => {
  props.switchContentLoading?.(false);
});
</script>
